import { Component, Input } from "@angular/core";
import { Subject } from "rxjs";
import { FilterSettings } from "models/reports/filters/FilterSettings";

@Component({
    selector: "financial-report-filter",
    templateUrl: "financial-report-filter.html",
    host: { "[class.c-report-filter]": "true" },
})
export class FinancialReportFilterComponent {
    @Input() public filterSubject: Subject<FilterSettings>;
}
